import React, { ReactNode, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@material-ui/core';
import { useStyles } from './styles';

interface ToolCardProps {
  category: string;
  title: string;
  description: string;
  type: 'logo' | 'icon' | 'browser' | 'preview' | 'custom';
  image?: string;
  icon?: ReactNode;
  customContent?: ReactNode;
  line: {
    initial: string;
    hover: string;
  };
  link: string;
}

const ToolCard: React.FC<ToolCardProps> = ({
  category,
  title,
  description,
  type,
  image,
  icon,
  customContent,
  line,
  link,
}) => {
  const styles = useStyles();
  const ref = useRef();
  const navigate = useNavigate();
  const [length, setLength] = React.useState(line.initial);
  const renderImageContent = () => {
    switch (type) {
      case 'logo':
        return (
          <div className={styles.imageWrapper}>
            {image && (
              <img src={image} alt={title} className={styles.logoImage} />
            )}
          </div>
        );

      case 'icon':
        return (
          <div className={styles.imageWrapper}>
            <div>{icon}</div>
          </div>
        );

      case 'browser':
        return (
          <div className={styles.imageWrapper}>
            <div className={styles.browserMockup}>
              <div className={styles.browserHeader}></div>
            </div>
            {icon && (
              <Box
                component="div"
                sx={{ position: 'absolute', top: '42px', left: '180px' }}
              >
                {icon}
              </Box>
            )}
          </div>
        );

      case 'preview':
        return (
          <div className={styles.imageWrapper}>
            {image && (
              <img src={image} alt={title} className={styles.previewImage} />
            )}
            <div className={styles.iconCircle}>
              <div>{icon}</div>
            </div>
          </div>
        );

      case 'custom':
        return <div className={styles.imageWrapper}>{customContent}</div>;

      default:
        return <div className={styles.imageWrapper}></div>;
    }
  };
  const onClick = () => {
    navigate(link);
  };
  const onMouseEnter = () => {
    const final = parseInt(line.hover.replace('px', ''), 10);
    const current = parseInt(length.replace('px', ''), 10);

    if (current !== final) {
      const interval = setInterval(() => {
        setLength(prevLength => {
          const currentLength = parseInt(prevLength.replace('px', ''), 10);
          if (currentLength < final) {
            return `${currentLength + 1}px`;
          } else if (currentLength > final) {
            return `${currentLength - 1}px`;
          } else {
            clearInterval(interval);
            return prevLength;
          }
        });
      }, 10); // Adjust the interval speed as needed
    }
  };
  const onMouseLeave = () => {
    setLength(line.initial);
  };

  return (
    <article
      className={styles.card}
      ref={ref}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
    >
      <div className={styles.imageContainer}>{renderImageContent()}</div>
      <div className={styles.contentContainer}>
        <div className={styles.category}>{category}</div>
        <div>
          <h3 className={styles.title}>{title}</h3>
          <div className={styles.underline} style={{ width: length }}></div>
        </div>
        <p className={styles.description}>{description}</p>
      </div>
    </article>
  );
};

export default ToolCard;
